import { useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  isProfilePageState,
  isUserRightsState,
  viewTypeState
} from "recoil/contentsAtom";
import FloatWrite from "components/community/floatWrite/FloatWrite";
import CommonInput from "./CommonInput/CommonInput";
import "./PageRight.scss";
import PostFeedContent from "./PostContent/PostFeedContent/PostFeedContent";
import PostListContent from "./PostContent/PostListContent/PostListContent";
import Promote from "./Promote/Promote";
import TopBar from "./topBar/TopBar";
import Footer from "components/common/footer/Footer";
import TopBanner from "./topbanner/TopBanner";
import { Service_CN, Service_GL } from "utils/CommonFunc";
import Cnfooter from "components/common/footer/CnFooter";
import { isLoginStateSelector, isPrivacyAgreeState } from "recoil/userInfoAtom";
import { youtubeIdState } from "recoil/commonUiAtom";

function PageRight() {
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const isUserRights = useRecoilValue(isUserRightsState);
  const viewType = useRecoilValue(viewTypeState);
  const youtubeId = useRecoilValue(youtubeIdState);
  const isPrivacyAgree = useRecoilValue(isPrivacyAgreeState);
  const { title } = useParams();
  const isProfilePage = useRecoilValue(isProfilePageState);

  const sectionType = title === undefined ? "all" : title;

  const writingRights = (title: string) => {
    for (let i = 0; i < isUserRights.length; i++) {
      if (isUserRights[i].title === title) {
        return isUserRights[i].admin_flag;
      }
    }
  };

  return (
    <div className="page-right">
      {Service_GL ? <TopBanner /> : null}
      {!isProfilePage && <TopBar />}
      {/* <Audio /> */}
      {youtubeId !== null && <Promote />}

      <div className="top-comment">
        {!isLoginState.isLogIn ? (
          <CommonInput type="login" />
        ) : isProfilePage ? (
          <CommonInput type="profile" />
        ) : writingRights(sectionType) === 0 ? (
          // 어드민 권한이 없는 section만 나타남
          <CommonInput type={isPrivacyAgree ? "content" : "privacyAgree"} />
        ) : null}
      </div>

      {writingRights(sectionType) === 0 || isProfilePage ? (
        <FloatWrite />
      ) : null}

      {isProfilePage || viewType === "feed" ? (
        <PostFeedContent />
      ) : (
        <PostListContent />
      )}
      {Service_CN ? <Cnfooter /> : <Footer />}
    </div>
  );
}

export default PageRight;
